import { Component, computed, inject, input, ChangeDetectionStrategy } from '@angular/core';

import { ButtonComponent, ILink, Image, ImageItemComponent, LinkDirective, MediaImage, SliderComponent, SpacerComponent } from '@sirius/common';
import { EbooksContent } from 'matchmaking/models';
import { MatchmakingTranslateService } from 'matchmaking/services';
import { InterpolatePipe } from 'shared/pipes';

@Component({
    selector: 'matchmaking-ebooks',
    imports: [InterpolatePipe, ButtonComponent, ImageItemComponent, LinkDirective, SliderComponent, SpacerComponent],
    templateUrl: './ebooks.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './ebooks.component.scss'
})
export class EbooksComponent {
    translationService = inject(MatchmakingTranslateService);

    application = input.required<string>();
    ebooks = input.required<EbooksContent[]>();

    translations = computed(() => this.translationService.translations());

    cardItems = computed(() => {
        if (!this.ebooks()?.length) {
            return [];
        }

        const items: any[] = [];

        this.ebooks().forEach((ebooks: EbooksContent) => {
            ebooks.media.forEach((media) => {
                if (!media?.thumbnail?.image) return;

                items.push({
                    title: media.title,
                    thumbnail: new MediaImage(
                        new Image(media.thumbnail.image.url, media.thumbnail.image.source),
                        media.thumbnail.title,
                    ),
                    ebook: {
                        title: media.title,
                        href: media.ebook.href,
                        target: '_blank',
                        rel: 'noopener noreferrer',
                        isFile: true,
                        routeType: 'browser',
                    } as ILink,
                });
            });
        });

        return items;
    });
}
